export default "__VITE_ASSET__CtzqKvXP__"